import { Component, forwardRef, Input, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputBase } from '../input-base/input-base';

const INPUT_TEXTAREA_VALUE_ACCESSOR = {
	provide: NG_VALUE_ACCESSOR,
	// eslint-disable-next-line no-use-before-define, @typescript-eslint/no-use-before-define
	useExisting: forwardRef(() => InputTextareaComponent),
	multi: true,
};

@Component({
	selector: 'app-input-textarea',
	templateUrl: './input-textarea.component.html',
	styleUrls: ['../input-base/input-styles.scss', './input-textarea.component.scss'],
	providers: [INPUT_TEXTAREA_VALUE_ACCESSOR],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class InputTextareaComponent extends InputBase {
	@Input() maxlength: number = null;

	@Input() minlength: number = null;

	@Input() rows: number = null;

	@Input() cols: number = null;

	@Input() resize: 'both' | 'vertical' | 'horizontal' | 'none' = 'none';
}
